import Vue from 'vue';
import Router from 'vue-router';
import { authService } from './services/AuthService';
import Login from './Login.vue';
import UsuarioList from './views/Usuario/UsuarioList.vue';
import SorteoList from './views/Sorteo/SorteoList.vue';
import SorteoDetail from './views/Sorteo/Detail/SorteoDetail.vue';

Vue.use(Router);

export const router = new Router({
  mode: 'history',
  routes: [
    { path: '/', component: SorteoList, },
    { path: '/sorteo/:id', component: SorteoDetail, },
    { path: '/login', component: Login, },
    { path: '/usuarios', component: UsuarioList, },
    { path: '*', redirect: '/' }
  ],
});

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const authRequired = '/login' !== to.path;

  if (authRequired && !authService.isAuthenticated()) {
    console.log("Redirect to login");
    return next('/login');
  }
  
  next();
});
